import config from "./config";
import { profile } from "../stores/storages/ProfileStorage";
import api from "./api";
import formatter from './formatter'
import axios from 'axios'
import lodash from 'lodash'
import { COUNTRY_CODE } from '../config'

const PREFIX = '[STICKER JS]'
const DefaultOptions = {
    fullPath: false,
    customKey: profile.authAPI.token,
    decrypt: true,
  }

const StickerService = {
  getStickers: async () => {
    const { username: msisdn, token } = profile.authAPI;
    const timestamp = new Date().getTime();
    const dataEncrypt = formatter.encrypt(
      `${msisdn}${token}${timestamp}`
    );

    const data = {
      params: {
        msisdn,
        reqTime: timestamp,
        countryCode: COUNTRY_CODE,
        dataEncrypt,
      },
    };
    const options = null;
    
    const res = await api.request({   //api.request
      method: config.endpoints.sticker.getCollections.method,
      path: config.endpoints.sticker.getCollections.path,
      host: config.host,
      data,
      options,
    });
    return res;
  },

  getCollectionDetail: async (collection) => {    
    const { collectionId } = collection
    const res = await axios.get(`${config.host}/sticker/${collectionId}/info.json`)
    if (lodash.has(res, 'data.stickerCollection')) {
      if (res.data.stickerCollection && res.data.stickerCollection.length > 0) {
        const info = res.data.stickerCollection[0]
        if (info && info.stickers) {
          collection.stickers = info.stickers
          collection.isDownloaded = true
          collection.isDownload = true
        }
      }

    }
    return collection;
  },
};

export default StickerService;
